module.exports = __webpack_public_path__ + "static/media/img110.694a0fed.jpg";